import type { JSX } from 'react'
import type { ILabelGroupTemplate3Props } from 'blocks/LabelGroup/Templates'
import type { ITextBlockTVShowsProps } from 'blocks/TextBlock/Templates'
import type { IDescriptionProps } from '../../Description'

import { LabelGroupTemplate6 } from 'blocks/LabelGroup/Templates'
import { TextBlockTVShowsInfo } from 'blocks/TextBlock/Templates'
import { Description } from '../../Description'
import { DescriptionColumnGap, DescriptionRowGap } from '../../Description.h'

export interface ITVShowDescriptionProps extends Omit<
  IDescriptionProps,
  'children'
> {
  title?: ITextBlockTVShowsProps['title']
  description?: ITextBlockTVShowsProps['description']
  list?: ILabelGroupTemplate3Props['list']
  quality?: string
  dolbyAtmos?: boolean
}

export const TVShowDescription = ({
  title = '',
  description = '',
  list = [],
  columnGap = DescriptionColumnGap.INDENT_0,
  rowGap = DescriptionRowGap.INDENT_20,
  quality,
  dolbyAtmos,
  ...rest
}: ITVShowDescriptionProps): JSX.Element => (
  <Description columnGap={columnGap} rowGap={rowGap} {...rest}>
    <TextBlockTVShowsInfo
      title={title}
      description={description}
      rowGap={rowGap}
    />
    <LabelGroupTemplate6
      list={list}
      quality={quality}
      dolbyAtmos={dolbyAtmos}
    />
  </Description>
)
